var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightSection(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 106,
    viewBox: "0 0 64 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    },
    opacity: 0.6
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61 29.1947L60.6088 24.4734L56.0593 23.7998C55.4909 21.9172 54.5834 20.1541 53.3813 18.5973L55.4876 14.5076L51.8769 11.4402L48.1879 14.1828C46.4526 13.2496 44.5626 12.6383 42.6093 12.3785L41.2011 8L36.477 8.39094L35.809 12.9378C33.923 13.5046 32.1567 14.4117 30.5975 15.6142L26.5054 13.5092L23.4422 17.1178L26.1864 20.8046C25.2513 22.5383 24.6396 24.4275 24.381 26.3799L20 27.7873L20.3912 32.5086L24.9407 33.1762C25.5014 35.0687 26.405 36.8423 27.6066 38.4087L25.5004 42.4985L29.1111 45.5598L32.8061 42.8172C34.5382 43.7528 36.4267 44.3643 38.3787 44.6215L39.7869 49L44.5109 48.6091L45.1849 44.0622C47.0686 43.4941 48.8327 42.5871 50.3904 41.3858L54.4826 43.4908L57.5517 39.8822L54.8316 36.1834C55.7653 34.4513 56.377 32.5643 56.637 30.6141L61 29.1947ZM48.4045 35.209C47.0798 36.7704 45.3217 37.9041 43.3524 38.4668C41.383 39.0295 39.2909 38.9961 37.3406 38.3706C35.3904 37.7451 33.6694 36.5557 32.3955 34.9528C31.1215 33.3499 30.3517 31.4054 30.1834 29.3653C30.0151 27.3252 30.4559 25.281 31.45 23.4912C32.4441 21.7014 33.9469 20.2464 35.7684 19.3101C37.5898 18.3739 39.6482 17.9985 41.6832 18.2313C43.7181 18.4641 45.6383 19.2947 47.2009 20.6182C49.2933 22.393 50.5954 24.9252 50.821 27.6587C51.0467 30.3922 50.1776 33.1035 48.4045 35.197V35.209Z",
    fill: "url(#paint0_linear_2503_22737)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2474 100.444C52.185 100.386 52.148 100.305 52.1442 100.219C52.0603 97.4441 50.8777 94.8157 48.8562 92.9121C46.8347 91.0086 44.14 89.9858 41.3646 90.0686C41.28 90.0705 41.1981 90.0391 41.1365 89.9811C41.0749 89.9231 41.0386 89.8432 41.0355 89.7587C41.0331 89.7159 41.0394 89.673 41.0541 89.6328C41.0688 89.5925 41.0915 89.5556 41.1209 89.5244C41.1503 89.4932 41.1857 89.4683 41.225 89.4512C41.2644 89.4341 41.3068 89.4252 41.3497 89.4251C44.2919 89.3466 47.1458 90.435 49.2887 92.4529C51.4315 94.4707 52.6892 97.2541 52.7875 100.196C52.7899 100.239 52.7836 100.281 52.7689 100.322C52.7542 100.362 52.7315 100.399 52.7021 100.43C52.6727 100.461 52.6373 100.486 52.5979 100.503C52.5586 100.52 52.5162 100.529 52.4733 100.529C52.3897 100.532 52.3084 100.501 52.2474 100.444Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.989 100.319C48.9267 100.26 48.8897 100.18 48.8859 100.094C48.8602 99.1739 48.653 98.2678 48.2762 97.4279C47.8994 96.5879 47.3604 95.8306 46.6902 95.1994C46.0199 94.5683 45.2317 94.0758 44.3706 93.75C43.5095 93.4243 42.5926 93.2719 41.6724 93.3015C41.5868 93.303 41.504 93.271 41.4417 93.2123C41.3794 93.1536 41.3425 93.0729 41.3388 92.9873C41.3369 92.9028 41.3683 92.8208 41.4263 92.7592C41.4843 92.6977 41.5642 92.6614 41.6487 92.6582C43.6729 92.5987 45.6378 93.3451 47.1121 94.7333C48.5863 96.1216 49.4493 98.0382 49.5114 100.062C49.5141 100.105 49.508 100.147 49.4936 100.187C49.4793 100.227 49.4569 100.263 49.4278 100.294C49.3987 100.325 49.3637 100.349 49.3247 100.366C49.2858 100.383 49.2439 100.392 49.2015 100.391C49.1242 100.394 49.0486 100.368 48.989 100.319Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0658 100.595C46.005 100.538 45.9696 100.459 45.9672 100.375C45.9512 99.8155 45.825 99.2646 45.5957 98.7539C45.3665 98.2433 45.0387 97.7829 44.6312 97.3992C44.2236 97.0154 43.7444 96.7159 43.2209 96.5177C42.6974 96.3195 42.14 96.2265 41.5805 96.2442C41.4959 96.2461 41.414 96.2146 41.3524 96.1567C41.2908 96.0987 41.2545 96.0188 41.2514 95.9342C41.2499 95.8486 41.2819 95.7658 41.3406 95.7035C41.3993 95.6412 41.48 95.6043 41.5656 95.6006C42.8637 95.5645 44.1234 96.044 45.0688 96.9344C46.0143 97.8247 46.5686 99.0533 46.6105 100.351C46.612 100.437 46.5799 100.52 46.5213 100.582C46.4626 100.644 46.3818 100.681 46.2963 100.685C46.2538 100.686 46.2116 100.679 46.1719 100.664C46.1323 100.648 46.0962 100.625 46.0658 100.595Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7896 100.413C42.2826 100.877 43.0586 100.854 43.5229 100.361C43.9871 99.868 43.9638 99.092 43.4708 98.6277C42.9778 98.1635 42.2018 98.1868 41.7375 98.6798C41.2733 99.1728 41.2966 99.9488 41.7896 100.413Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2639 59.4499L62.1956 61.8071C62.275 61.9063 62.3122 62.0325 62.2995 62.1587C62.2868 62.285 62.225 62.4014 62.1274 62.4833L48.0357 73.893C47.9408 73.9701 47.82 74.0086 47.6978 74.0007C47.6316 73.9974 47.5669 73.9801 47.5079 73.95C47.449 73.92 47.3972 73.8778 47.356 73.8262L45.4243 71.4691C45.3847 71.4203 45.3552 71.3642 45.3375 71.304C45.3198 71.2437 45.3142 71.1806 45.3212 71.1182C45.3281 71.0558 45.3473 70.9954 45.3778 70.9404C45.4083 70.8854 45.4494 70.8369 45.4987 70.7977L59.5897 59.3824C59.6382 59.3421 59.6942 59.3117 59.7546 59.2933C59.815 59.2748 59.8785 59.2685 59.9413 59.2748C60.0042 59.2811 60.0651 59.2998 60.1205 59.3299C60.1759 59.36 60.2246 59.4008 60.2639 59.4499Z",
    fill: "#FFCA11"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2653 59.4501L62.197 61.8073C62.2764 61.9065 62.3136 62.0327 62.3009 62.1589C62.2882 62.2852 62.2265 62.4016 62.1289 62.4835L60.8834 63.4933L58.3456 60.3925L59.5911 59.3826C59.6396 59.3422 59.6956 59.3119 59.756 59.2934C59.8164 59.275 59.8799 59.2687 59.9428 59.275C60.0056 59.2813 60.0665 59.3 60.1219 59.3301C60.1773 59.3602 60.2261 59.401 60.2653 59.4501Z",
    fill: "#E08309"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4062 60.3669L55.5996 62.6396L58.1365 65.7401L60.943 63.4674L58.4062 60.3669Z",
    fill: "#FFAF0A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6914 70.6582L48.2228 73.7543",
    stroke: "#E09A09",
    strokeWidth: 0.43,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9258 69.6572L49.4628 72.7525",
    stroke: "#E09A09",
    strokeWidth: 0.43,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1641 68.6533L50.7011 71.7486",
    stroke: "#E09A09",
    strokeWidth: 0.43,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4082 67.6494L51.9396 70.7455",
    stroke: "#E09A09",
    strokeWidth: 0.43,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6504 66.6445L53.1818 69.7406",
    stroke: "#E09A09",
    strokeWidth: 0.43,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8887 65.6416L54.4201 68.7376",
    stroke: "#E09A09",
    strokeWidth: 0.43,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M53.123 64.6406L55.66 67.7359",
    stroke: "#E09A09",
    strokeWidth: 0.43,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3633 63.6299L56.901 66.7307",
    stroke: "#E09A09",
    strokeWidth: 0.43,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6035 62.626L58.1357 65.7276",
    stroke: "#E09A09",
    strokeWidth: 0.43,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8457 61.623L59.3779 64.7246",
    stroke: "#E09A09",
    strokeWidth: 0.43,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0859 60.6191L60.6181 63.7207",
    stroke: "#E09A09",
    strokeWidth: 0.43,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3203 59.6162L61.8573 62.7115",
    stroke: "#E09A09",
    strokeWidth: 0.43,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M53.0865 64.6662L53.5891 67.7244L53.8348 69.2118L52.4304 70.3505L52.1168 68.4426L51.6814 65.7992L53.0865 64.6662Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M46.9696 69.6113L47.4778 72.6687L47.6984 74.0126C47.6322 74.0093 47.5675 73.992 47.5086 73.9619C47.4497 73.9319 47.3979 73.8897 47.3566 73.8381L45.7575 71.8828L45.5708 70.7491L46.9696 69.6113Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M56.1417 62.1918L56.3653 63.5579L56.8869 66.7153L56.8899 66.7375L54.3628 68.7846L54.3371 68.6355L53.8226 65.4885L53.6194 64.2327L56.1417 62.1918Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2503_22737)"
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0604 84.6983L21.4692 80.7107C21.3178 80.6414 21.1469 80.6273 20.9864 80.6708C20.8259 80.7142 20.686 80.8125 20.5912 80.9485L19.3318 82.7485C19.2369 82.8845 19.097 82.9828 18.9366 83.0263C18.7761 83.0697 18.6052 83.0556 18.4537 82.9863L7.52851 78.444C7.42869 78.3983 7.31977 78.376 7.21009 78.3786C7.10042 78.3813 6.9929 78.409 6.89577 78.4596C6.79864 78.5101 6.71447 78.5821 6.64971 78.6702C6.58496 78.7583 6.54134 78.86 6.52218 78.9676L2.64342 94.807C2.58783 95.0407 2.61563 95.2867 2.72204 95.5029C2.82846 95.719 3.00686 95.8917 3.22666 95.9914L25.9728 105.448C26.0726 105.494 26.1815 105.516 26.2912 105.514C26.4009 105.511 26.5084 105.483 26.6055 105.433C26.7026 105.382 26.7868 105.31 26.8516 105.222C26.9163 105.134 26.9599 105.032 26.9791 104.925L31.6454 85.871C31.6973 85.6387 31.6675 85.3955 31.561 85.182C31.4545 84.9686 31.2778 84.7978 31.0604 84.6983Z",
    fill: "url(#paint1_linear_2503_22737)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3034 76.1456L16.0371 67.7197L8.42704 86.0237L28.6933 94.4496L36.3034 76.1456Z",
    fill: "url(#paint2_linear_2503_22737)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9971 78.4339L17.457 72.3887L17.0185 73.4435L31.5586 79.4887L31.9971 78.4339Z",
    fill: "url(#paint3_linear_2503_22737)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5479 81.9163L16.0078 75.8711L15.5693 76.9259L30.1093 82.9711L30.5479 81.9163Z",
    fill: "url(#paint4_linear_2503_22737)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1006 85.3997L14.5605 79.3545L14.122 80.4093L28.6621 86.4545L29.1006 85.3997Z",
    fill: "url(#paint5_linear_2503_22737)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5445 87.0767L27.1069 104.966C27.0184 105.179 26.8484 105.348 26.6345 105.435C26.4205 105.523 26.1801 105.522 25.9661 105.433L3.23078 95.981C3.01678 95.8921 2.84673 95.7221 2.75803 95.5086C2.66933 95.295 2.66925 95.0554 2.75781 94.8424L8.94538 79.9599C9.0365 79.7506 9.20658 79.5858 9.41894 79.5008C9.63131 79.4158 9.86894 79.4175 10.0806 79.5056L21.0058 84.0478C21.1659 84.1109 21.341 84.1254 21.509 84.0897C21.6771 84.054 21.8306 83.9696 21.9505 83.8471L23.5165 82.1746C23.6371 82.0487 23.7929 81.9619 23.9639 81.9255C24.1348 81.8891 24.313 81.9047 24.4752 81.9704L34.0637 85.9569C34.2777 86.0458 34.4478 86.2158 34.5365 86.4293C34.6252 86.6429 34.6252 86.8825 34.5367 87.0955L34.5445 87.0767Z",
    fill: "url(#paint6_linear_2503_22737)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5593 85.7374L13.7173 100.328L11.259 99.306L31.1037 84.7165L33.5593 85.7374Z",
    fill: "url(#paint7_linear_2503_22737)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5456 87.0768L32.1358 92.873L19.0056 102.527L14.9228 100.829L34.5369 86.4075C34.5839 86.5128 34.6089 86.6264 34.6104 86.7415C34.6119 86.8566 34.5899 86.9707 34.5456 87.0768Z",
    fill: "url(#paint8_linear_2503_22737)"
  })))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8958 11.6673C16.5267 11.8098 15.1436 11.5336 13.9763 10.8844C12.809 10.2353 11.9277 9.25233 11.4788 8.09876C11.361 7.77571 11.2787 7.44338 11.233 7.10637C11.2106 6.94393 11.1978 6.78058 11.1946 6.61696C11.1946 6.10377 11.5364 6.2771 11.6785 5.79789C11.7313 5.62189 11.7941 5.44834 11.8666 5.27791C11.9735 5.02714 12.1018 4.78398 12.2507 4.5506C12.7938 3.6919 13.594 2.98235 14.5631 2.4999C15.5323 2.01745 16.633 1.78079 17.7442 1.81591C18.8555 1.85103 19.9343 2.15659 20.8621 2.699C21.7899 3.2414 22.5308 3.99966 23.0034 4.89046C23.0906 5.16306 23.1522 5.44156 23.1877 5.72312C23.2253 5.99366 23.2381 6.26643 23.2261 6.53879C23.2077 6.98776 23.1264 7.43297 22.9842 7.86425C22.6468 8.86817 21.9843 9.76251 21.0785 10.4366C20.1728 11.1108 19.0636 11.5351 17.8882 11.6571L17.8958 11.6673Z",
    fill: "#FFAF0A"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1864 11.6506C17.4212 11.6512 17.6558 11.6399 17.8892 11.6166C18.769 11.5259 19.6151 11.2632 20.3663 10.8477C21.1174 10.4321 21.7549 9.87405 22.2325 9.21382C22.5385 8.79293 22.7739 8.33502 22.9314 7.85437C22.99 7.68218 23.0387 7.5075 23.0774 7.33098C23.1321 7.06948 23.1654 6.80484 23.1772 6.5391C23.1856 6.27015 23.1728 6.001 23.1388 5.73363C23.1007 5.45466 23.0391 5.1786 22.9545 4.90777C22.598 3.7986 21.843 2.82241 20.8036 2.12699C19.7642 1.43158 18.4971 1.05481 17.1941 1.05373C16.9593 1.05317 16.7246 1.06451 16.4913 1.08771C15.5512 1.18713 14.6508 1.48149 13.8634 1.94684C13.076 2.41219 12.4238 3.0354 11.9598 3.76583C11.8126 3.99877 11.6842 4.24068 11.5758 4.48973C11.5066 4.65627 11.4452 4.8296 11.3914 5.00293C11.2487 5.48521 11.1841 5.98297 11.1994 6.48132C11.2024 6.64269 11.2152 6.80379 11.2378 6.96393C11.2865 7.34243 11.3818 7.71509 11.522 8.07528C11.9273 9.11682 12.6898 10.0204 13.7031 10.6602C14.7165 11.2999 15.9301 11.6437 17.1749 11.6438L17.1864 11.6506Z",
    fill: "#FFCA11"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2008 1.11123C16.9684 1.11183 16.7364 1.12432 16.5057 1.14862C15.5737 1.24732 14.6815 1.5399 13.9018 2.00243C13.1222 2.46497 12.4774 3.08429 12.0203 3.80974C11.873 4.03915 11.7446 4.27767 11.6362 4.52345C11.5671 4.68998 11.5057 4.86331 11.4519 5.02984C11.3128 5.50804 11.2495 6.00102 11.2637 6.49465C11.2668 6.656 11.2796 6.81711 11.3021 6.97726C11.35 7.35114 11.444 7.71925 11.5825 8.075C11.9836 9.10613 12.7383 10.0008 13.7412 10.6344C14.7442 11.268 15.9455 11.6089 17.1777 11.6096C17.41 11.609 17.6421 11.5965 17.8728 11.5722C18.7438 11.483 19.5814 11.2232 20.3247 10.8117C21.068 10.4002 21.6984 9.84727 22.1701 9.19315C22.4733 8.7775 22.7074 8.32539 22.8651 7.8507C22.9237 7.68108 22.9712 7.50859 23.0072 7.33411C23.062 7.07604 23.0953 6.81479 23.1071 6.55243C23.1155 6.28573 23.1026 6.01885 23.0687 5.75375C23.0339 5.47655 22.9723 5.20251 22.8844 4.93468C22.5325 3.83795 21.7869 2.87238 20.7601 2.18383C19.7334 1.49528 18.4813 1.12116 17.1931 1.11802M17.1931 1.01267C18.5082 1.01503 19.7867 1.39645 20.835 2.09919C21.8834 2.80193 22.6446 3.78776 23.0034 4.9075C23.0906 5.1801 23.1522 5.45859 23.1877 5.74015C23.2253 6.01069 23.2381 6.28346 23.2261 6.55582C23.2077 7.00479 23.1264 7.45001 22.9842 7.88129C22.6468 8.8852 21.9843 9.77955 21.0785 10.4537C20.1728 11.1278 19.0636 11.5521 17.8882 11.6742C17.6525 11.7 17.4152 11.7125 17.1777 11.7115C15.921 11.7101 14.696 11.362 13.6732 10.7157C12.6504 10.0694 11.8807 9.15708 11.4711 8.1056C11.328 7.74227 11.2301 7.36619 11.1792 6.98405C11.16 6.82092 11.1447 6.64419 11.1408 6.49465C11.1259 5.99049 11.1918 5.48701 11.3367 4.99925C11.3904 4.82592 11.4519 4.6594 11.5249 4.48267C11.6309 4.23162 11.7593 3.98842 11.9089 3.75536C12.3718 3.01277 13.0283 2.37868 13.8238 1.90579C14.6193 1.4329 15.5308 1.13486 16.4826 1.03646C16.7183 1.01057 16.9556 0.998083 17.1931 0.999079V1.01267Z",
    fill: "#E08309"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M14.0023 9.90835C11.7922 8.34805 11.4298 5.49756 13.1928 3.54161C14.9559 1.58567 18.1768 1.26493 20.3869 2.82523C22.597 4.38552 22.9594 7.236 21.1964 9.19195C19.4333 11.1479 16.2124 11.4686 14.0023 9.90835Z",
    stroke: "white",
    strokeWidth: 1.26,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1846 10.2691C17.3592 10.2702 17.5336 10.2611 17.7069 10.2419C18.8235 10.1247 19.8474 9.63467 20.5695 8.87188C21.2916 8.10909 21.6574 7.1311 21.5922 6.13766C21.527 5.14422 21.0357 4.21029 20.2187 3.52661C19.4017 2.84293 18.3205 2.46108 17.1961 2.45906C17.0228 2.45805 16.8496 2.46714 16.6777 2.48625C15.5614 2.60341 14.5377 3.09319 13.8156 3.85562C13.0935 4.61805 12.7275 5.59564 12.7921 6.58882C12.8568 7.582 13.3474 8.51588 14.1637 9.19983C14.98 9.88378 16.0605 10.2662 17.1846 10.2691Z",
    fill: "#E09A09"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1969 2.50184C17.0262 2.50243 16.8557 2.51152 16.6862 2.52904C15.5852 2.64533 14.5758 3.12888 13.8639 3.88111C13.1519 4.63334 12.7909 5.59759 12.8546 6.57723C12.9183 7.55688 13.4018 8.47814 14.2065 9.15316C15.0113 9.82818 16.0766 10.2061 17.1854 10.2099C17.3574 10.2094 17.5292 10.2004 17.7 10.1827C18.8013 10.0664 19.8109 9.58256 20.5229 8.82997C21.2348 8.07738 21.5956 7.11274 21.5314 6.13284C21.4672 5.15295 20.983 4.23165 20.1775 3.5569C19.372 2.88215 18.306 2.5048 17.1969 2.50184ZM17.1969 2.39648C18.3374 2.39846 19.4339 2.78578 20.2624 3.4793C21.091 4.17281 21.589 5.12017 21.6547 6.12776C21.7204 7.13536 21.3488 8.12712 20.6159 8.90039C19.883 9.67365 18.8441 10.17 17.7115 10.2881C17.5369 10.3056 17.3612 10.3147 17.1854 10.3153C16.045 10.3133 14.9485 9.92599 14.1199 9.23247C13.2914 8.53895 12.7934 7.5916 12.7277 6.58401C12.662 5.57641 13.0335 4.58464 13.7664 3.81138C14.4993 3.03812 15.5382 2.54174 16.6708 2.42368C16.8455 2.40625 17.0211 2.39717 17.1969 2.39648Z",
    fill: "#E08309"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M22.2836 9.24828L11.1469 6.492C11.1317 5.98896 11.1977 5.48657 11.3427 5L22.9902 7.88883C22.8282 8.36915 22.5903 8.82682 22.2836 9.24828Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M23.1192 7.34825L11.5331 4.49001C11.6392 4.23896 11.7676 3.99575 11.9171 3.7627L23.2344 6.56317C23.2187 6.82708 23.1802 7.08954 23.1192 7.34825Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2503_22737",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 4,
    width: 13,
    height: 9
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2321 12.4745C15.2943 12.777 12.3757 10.6358 11.4809 8.10045C11.8979 9.17385 12.6895 10.1022 13.7416 10.7514C14.7937 11.4005 16.0517 11.7369 17.3339 11.712C18.6161 11.687 19.8562 11.3019 20.875 10.6125C21.8938 9.92298 22.6386 8.96473 23.0017 7.87614C23.1439 7.44486 23.2252 6.99965 23.2437 6.55068C23.2556 6.27832 23.2428 6.00555 23.2053 5.73501C23.1698 5.45345 23.1081 5.17494 23.0209 4.90234C23.2926 5.41906 23.4689 5.97097 23.5432 6.53708C23.5769 6.80788 23.5898 7.08041 23.5816 7.35276C23.5707 7.62097 23.536 7.88801 23.4779 8.15143C23.4395 8.33155 23.3934 8.50828 23.3358 8.68161C23.1736 9.16248 22.9344 9.62028 22.6254 10.0411C22.144 10.7106 21.4998 11.2765 20.7397 11.6975C19.9796 12.1185 19.1229 12.3839 18.2321 12.4745Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2503_22737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2321 12.4745C15.2943 12.777 12.3757 10.6358 11.4809 8.10045C11.8979 9.17385 12.6895 10.1022 13.7416 10.7514C14.7937 11.4005 16.0517 11.7369 17.3339 11.712C18.6161 11.687 19.8562 11.3019 20.875 10.6125C21.8938 9.92298 22.6386 8.96473 23.0017 7.87614C23.1439 7.44486 23.2252 6.99965 23.2437 6.55068C23.2556 6.27832 23.2428 6.00555 23.2053 5.73501C23.1698 5.45345 23.1081 5.17494 23.0209 4.90234C23.2926 5.41906 23.4689 5.97097 23.5432 6.53708C23.5769 6.80788 23.5898 7.08041 23.5816 7.35276C23.5707 7.62097 23.536 7.88801 23.4779 8.15143C23.4395 8.33155 23.3934 8.50828 23.3358 8.68161C23.1736 9.16248 22.9344 9.62028 22.6254 10.0411C22.144 10.7106 21.4998 11.2765 20.7397 11.6975C19.9796 12.1185 19.1229 12.3839 18.2321 12.4745Z",
    fill: "#FFAF0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1376 5.93945L24.2129 6.85708",
    stroke: "#E09A09",
    strokeWidth: 0.37,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0868 6.66992L24.1621 7.58755",
    stroke: "#E09A09",
    strokeWidth: 0.37,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9833 7.57324L24.0586 8.49087",
    stroke: "#E09A09",
    strokeWidth: 0.37,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6885 8.33887L23.7676 9.2565",
    stroke: "#E09A09",
    strokeWidth: 0.37,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3545 9.00488L23.4336 9.92251",
    stroke: "#E09A09",
    strokeWidth: 0.37,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.872 9.58887L22.9473 10.5065",
    stroke: "#E09A09",
    strokeWidth: 0.37,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.329 10.167L22.4043 11.0846",
    stroke: "#E09A09",
    strokeWidth: 0.37,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.704 10.6426L21.7793 11.5602",
    stroke: "#E09A09",
    strokeWidth: 0.37,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9755 11.0127L21.0508 11.9269",
    stroke: "#E09A09",
    strokeWidth: 0.37,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1709 11.373L20.25 12.2907",
    stroke: "#E09A09",
    strokeWidth: 0.37,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2998 11.6006L19.3789 12.5182",
    stroke: "#E09A09",
    strokeWidth: 0.37,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3974 11.5566L18.4766 12.6",
    stroke: "#E09A09",
    strokeWidth: 0.37,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4738 11.4717L17.6758 12.5762",
    stroke: "#E09A09",
    strokeWidth: 0.37,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4022 11.3799L16.4199 12.5014",
    stroke: "#E09A09",
    strokeWidth: 0.37,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.332 10.9316L15.123 12.0974",
    stroke: "#E09A09",
    strokeWidth: 0.37,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3788 10.3867L14.1699 11.5524",
    stroke: "#E09A09",
    strokeWidth: 0.37,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2503_22737",
    x1: 40.503,
    y1: -227.625,
    x2: 40.503,
    y2: 83.1797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCD0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4467FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#040768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2503_22737",
    x1: 10.3554,
    y1: 62.5474,
    x2: 17.3752,
    y2: 91.8258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4DC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2503_22737",
    x1: 25.3796,
    y1: 73.5727,
    x2: 16.9075,
    y2: 94.6866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDE8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A793FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2503_22737",
    x1: 25.9013,
    y1: 59.4303,
    x2: 23.5597,
    y2: 86.2723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDE8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A793FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2503_22737",
    x1: 24.7565,
    y1: 59.3279,
    x2: 22.4149,
    y2: 86.1698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDE8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A793FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2503_22737",
    x1: 23.6124,
    y1: 59.229,
    x2: 21.2708,
    y2: 86.0709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDE8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A793FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2503_22737",
    x1: 22.9318,
    y1: 73.7174,
    x2: 11.8546,
    y2: 118.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4DC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2503_22737",
    x1: 60.9758,
    y1: 79.568,
    x2: 15.8367,
    y2: 94.9626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2503_22737",
    x1: 62.02,
    y1: 82.627,
    x2: 16.8809,
    y2: 98.0216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2503_22737"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 31,
    fill: "white",
    transform: "translate(11.9004 66) rotate(22.5756)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightSection);
export default __webpack_public_path__ + "static/media/right_section.0b5c2bd39583a3058466375045314879.svg";
export { ForwardRef as ReactComponent };